import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

const InsurancePolicies = () => {
    const [title, setTitle] = useState("Agregar Póliza");
    const [loading, setLoading] = useState(false);
    const [policy_id, setPolicyId] = useState(0);
    const [unit_id, setUnitId] = useState(0);
    const [nickname, setNickname] = useState('');
    const [serial, setSerial] = useState('');
    const [expiration_date, setExpirationDate] = useState('');
    const [file, setFile] = useState(null);
    const [policies, setPolicies] = useState([]);
    const [units, setUnits] = useState([]);
    const [status_filter, setStatusFilter] = useState(2);
    const [unit_filter, setUnitFilter] = useState(0);
    const [active, setActive] = useState(0);
    const [expired, setExpired] = useState(0);
    const [expiring, setExpiring] = useState(0);
    
    // Estados para el modal de visualización
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [currentPdfUrl, setCurrentPdfUrl] = useState('');
    const [currentFileName, setCurrentFileName] = useState('');

    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAll();
        getUnits();
        setTimeout(() => {
            initializeSelect2();
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    const initializeSelect2 = () => {
        $('#unit_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#status_filter').select2({ width: "100%" });
        $('#unit_filter').select2({ width: "100%" });
    };

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activas', value: 1 },
        { label: 'Próximas a vencer', value: 3 },
        { label: 'Vencidas', value: 0 }
    ];

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#unit_filter').on("change", function (e) {
        setUnitFilter(e.target.value);
    });

    $('#unit_id').on("change", function (e) {
        setUnitId(e.target.value);
    });

    // FUNCIÓN FALTANTE - Manejar cambio de archivo
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const getUnits = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-units-simple');
        const unitsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.unit_id,
            };
        })
        setUnits(unitsArray);
    };

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("unit_filter", unit_filter);
        await axios.post(ENDPOINT + "get-all-policies", form).then((response) => {
            setPolicies(response.data.data);
            
            // Calcular estadísticas
            const today = new Date();
            const thirtyDaysFromNow = new Date();
            thirtyDaysFromNow.setDate(today.getDate() + 30);
            
            const activePolicies = response.data.data.filter(policy => {
                const expDate = new Date(policy.expiration_date);
                return expDate > today;
            });
            
            const expiringPolicies = response.data.data.filter(policy => {
                const expDate = new Date(policy.expiration_date);
                return expDate > today && expDate <= thirtyDaysFromNow;
            });
            
            const expiredPolicies = response.data.data.filter(policy => {
                const expDate = new Date(policy.expiration_date);
                return expDate <= today;
            });
            
            setActive(activePolicies.length);
            setExpiring(expiringPolicies.length);
            setExpired(expiredPolicies.length);
            
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por apodo o serie",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("nickname", nickname);
        form.append("serial", serial);
        form.append("unit_id", unit_id);
        form.append("expiration_date", expiration_date);
        if (file) {
            form.append("file", file);
        }

        if (policy_id === 0) {
            await axios
                .post(ENDPOINT + "save-policy", form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .post(ENDPOINT + "update-policy/" + policy_id, form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setPolicyId(0);
        setNickname('');
        setSerial('');
        setUnitId(0);
        setExpirationDate('');
        setFile(null);
        setTitle("Agregar Póliza");
        $('#unit_id').val('0').trigger('change');
        $('#unit_id').select2('destroy');
        setTimeout(() => {
            initializeSelect2();
        }, 100);
    };


const handleViewPdf = async (policyId, fileName) => {
    try {
        setLoading(true);
        const response = await axios.get(ENDPOINT + "get-policy-file-url/" + policyId);
        
        if (response.data.res) {
            const pdfUrl = response.data.data.file_url;
            console.log('PDF URL:', pdfUrl); // Para debugging
            
            setCurrentPdfUrl(pdfUrl);
            setCurrentFileName(response.data.data.file_name);
            setShowPdfModal(true);
            
            // Pequeño delay para asegurar que el modal esté renderizado
            setTimeout(() => {
                const iframe = document.getElementById('pdf-viewer-iframe');
                if (iframe) {
                    // Forzar recarga del iframe
                    iframe.src = '';
                    setTimeout(() => {
                        iframe.src = pdfUrl;
                    }, 100);
                }
            }, 300);
        } else {
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }
        setLoading(false);
    } catch (error) {
        setLoading(false);
        Swal.fire({
            icon: "error",
            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
            showConfirmButton: true,
            html: '<div class="text-custom-alert">Error al cargar el archivo: ' + error.message + '</div>',
            showClass: { popup: "animate__animated animate__fadeInDown" },
            hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
    }
};

    

   const closePdfModal = () => {
    setShowPdfModal(false);
    setCurrentPdfUrl('');
    setCurrentFileName('');
};

    // Función para descargar el archivo
    const handleDownloadFile = async (policyId, fileName) => {
        try {
            setLoading(true);
            const response = await axios.get(ENDPOINT + "download-policy-file/" + policyId, {
                responseType: 'blob'
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error al descargar el archivo</div>',
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-policy/" + id)
            .then((response) => {
                setLoading(false);
                setPolicyId(response.data.data.policy_id);
                setNickname(response.data.data.nickname);
                setSerial(response.data.data.serial);
                setUnitId(response.data.data.unit_id);
                setExpirationDate(response.data.data.expiration_date.split('T')[0]);
                setTitle("Editar Póliza");
                $('#unit_id').removeClass('select2');
                setTimeout(() => {
                    $('#unit_id').addClass('select2');
                    initializeSelect2();
                }, 100);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, nickname) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${nickname} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-policy/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const getStatusBadge = (expirationDate) => {
        const today = new Date();
        const expDate = new Date(expirationDate);
        const thirtyDaysFromNow = new Date();
        thirtyDaysFromNow.setDate(today.getDate() + 30);
        
        if (expDate <= today) {
            return <span className="badge bg-danger">Vencida</span>;
        } else if (expDate <= thirtyDaysFromNow) {
            return <span className="badge bg-warning">Por vencer</span>;
        } else {
            return <span className="badge bg-success">Activa</span>;
        }
    };

    return (
        <>
            {loading && <Loader />}
            
            {/* Modal para Agregar/Editar Póliza */}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                {title === "Agregar Póliza" ? <i className="fas fa-plus-circle me-2"></i> : <i className="fa-solid fa-pen-to-square me-2"></i>}
                                {title}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearField}></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit} encType="multipart/form-data">
                            <div className="modal-body">
                                <div className="policies-form-header">
                                    <h3 className="policies-form-title">Información de la Póliza</h3>
                                    <p className="policies-form-subtitle">Complete los datos de la póliza para la gestión del sistema</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="nickname" className="col-form-label col-form-label-sm">
                                                Apodo de la Póliza <span className="policies-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese un apodo para la póliza"
                                                id="nickname"
                                                name="nickname"
                                                value={nickname}
                                                onChange={(e) => setNickname(e.target.value)}
                                                required
                                            />
                                            <small className="policies-field-hint">Nombre descriptivo para identificar la póliza</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="serial" className="col-form-label col-form-label-sm">
                                                Serie de la Unidad <span className="policies-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese la serie de la unidad"
                                                id="serial"
                                                name="serial"
                                                value={serial}
                                                onChange={(e) => setSerial(e.target.value)}
                                                required
                                            />
                                            <small className="policies-field-hint">Número de serie de la unidad asegurada</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="unit_id" className="col-form-label col-form-label-sm">
                                                Unidad Asociada <span className="policies-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="unit_id"
                                                name="unit_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {units.map((item, index) => (
                                                    <option
                                                        selected={item.value === unit_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="policies-field-hint">Seleccione la unidad asociada a esta póliza</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="expiration_date" className="col-form-label col-form-label-sm">
                                                Fecha de Vencimiento <span className="policies-required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="expiration_date"
                                                name="expiration_date"
                                                value={expiration_date}
                                                onChange={(e) => setExpirationDate(e.target.value)}
                                                required
                                            />
                                            <small className="policies-field-hint">Fecha en la que vence la póliza</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="file" className="col-form-label col-form-label-sm">
                                                Archivo de Póliza {policy_id === 0 ? <span className="policies-required">*</span> : ''}
                                            </label>
                                            <input
                                                type="file"
                                                className={`form-control form-control-sm`}
                                                id="file"
                                                name="file"
                                                onChange={handleFileChange}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                required={policy_id === 0}
                                            />
                                            <small className="policies-field-hint">Suba el PDF o imagen de la póliza (PDF, JPG, PNG)</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer policies-form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {policy_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={clearField}>
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {showPdfModal && (
    <div className="modal fade show d-block" id="pdfModal" tabIndex="-1" 
         aria-labelledby="pdfModalLabel" 
         style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050}}>
        <div className="modal-dialog modal-xl modal-dialog-centered" style={{maxWidth: '95%', height: '90vh'}}>
            <div className="modal-content h-100">
                <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title" id="pdfModalLabel">
                        <i className="fas fa-file-pdf me-2"></i>
                        Visualizando: {currentFileName}
                    </h5>
                    <button type="button" className="btn-close btn-close-white" 
                            onClick={closePdfModal}></button>
                </div>
                <div className="modal-body p-0" style={{height: 'calc(100% - 120px)'}}>
                    {currentPdfUrl ? (
                        <iframe 
                            id="pdf-viewer-iframe"
                            src={currentPdfUrl} 
                            width="100%" 
                            height="100%" 
                            frameBorder="0"
                            title={`PDF Viewer - ${currentFileName}`}
                            style={{border: 'none'}}
                        >
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-center">
                                    <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                                    <p>Tu navegador no soporta la visualización de PDF.</p>
                                    <a href={currentPdfUrl} 
                                       className="btn btn-primary"
                                       target="_blank" 
                                       rel="noopener noreferrer"
                                       download={currentFileName}>
                                        <i className="fas fa-download me-2"></i>
                                        Descargar PDF
                                    </a>
                                </div>
                            </div>
                        </iframe>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                                <p>Cargando PDF...</p>
                            </div>
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={closePdfModal}
                    >
                        <i className="fas fa-times me-1"></i> Cerrar
                    </button>
                    <a 
                        href={currentPdfUrl} 
                        className="btn btn-success"
                        download={currentFileName}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fas fa-download me-1"></i> Descargar
                    </a>
                </div>
            </div>
        </div>
    </div>
)}

            <div className="container-fluid">
                <ContentHeader title="Módulo de Pólizas de Seguro" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-file-earmark-medical me-2"></i> Listado de Pólizas de Seguro
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="policies-indications row mb-4">
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="policies-field-hint">Estado para filtrar las pólizas</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="unit_filter" className="col-form-label col-form-label-sm">
                                        Unidad
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="unit_filter"
                                        name="unit_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {units.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="policies-field-hint">Unidad para filtrar</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button" >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                            </div>
                            <div className="col-xs-3 col-md-3">
                                <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="text-center">
                                                <td className="indications-table" width="25%" >Total</td>
                                                <td className="indications-table" width="25%" >Activas</td>
                                                <td className="indications-table" width="25%" >Por vencer</td>
                                                <td className="indications-table" width="25%" >Vencidas</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TpoliciesT">{active + expired + expiring}</td>
                                                <td id="TpoliciesA">{active}</td>
                                                <td id="TpoliciesE">{expiring}</td>
                                                <td id="TpoliciesV">{expired}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th width="10%" className="text-center">#</th>
                                    <th width="15%" className="text-left">Apodo</th>
                                    <th width="15%" className="text-left">Serie</th>
                                    <th width="15%" className="text-left">Unidad</th>
                                    <th width="15%" className="text-center">Vencimiento</th>
                                    <th width="10%" className="text-center">Estado</th>
                                    <th width="10%" className="text-center">Archivo</th>
                                    <th width="10%" className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {policies.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.policy_id}</kbd>
                                        </td>
                                        <td>
                                            {item.nickname}
                                        </td>
                                        <td>
                                            {item.serial}
                                        </td>
                                        <td>
                                            {item.unit?.name}
                                        </td>
                                        <td className="text-center">
                                            {new Date(item.expiration_date).toLocaleDateString()}
                                        </td>
                                        <td className="text-center">
                                            {getStatusBadge(item.expiration_date)}
                                        </td>
                                        <td className="text-center">
    <div className="btn-group" role="group">
        <button
            className="btn-sm btn btn-info me-1"
            onClick={() => handleViewPdf(item.policy_id, item.file_original_name)}
            title="Ver archivo"
        >
            <i className="fa-solid fa-eye"></i>
        </button>
        <button
            className="btn-sm btn btn-success"
            onClick={() => handleDownloadFile(item.policy_id, item.file_original_name)}
            title="Descargar archivo"
        >
            <i className="fa-solid fa-download"></i>
        </button>
    </div>
</td>
                                        <td className="text-center">
                                            <div className="btn-group" role="group">
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modal-default"
                                                    className="btn-sm btn btn-warning me-1"
                                                    onClick={() => handleEdit(item.policy_id)}
                                                    title="Editar registro"
                                                >
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                </button>
                                                <button
                                                    className="btn-sm btn btn-danger"
                                                    onClick={() => handleDelete(item.policy_id, item.nickname)}
                                                    title="Eliminar registro"
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>
    )
}

export default InsurancePolicies;